module.exports = __webpack_public_path__ + "static/media/o_ec_optimize.30015a91.png";